import { Button } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import styles from '@styles';
import { ChevronLeftIcon } from '@radix-ui/react-icons';

export const BackButton = () => {
    const { t } = useTranslation('common');
    const navigate = useNavigate();

    return (
        <Button
            className={styles.link}
            variant={'ghost'}
            color={'gray'}
            onClick={() => navigate(-1)}
        >
            <ChevronLeftIcon />
            {t('buttons.back')}
        </Button>
    );
};
